import generalRequestErrorHandler from "../../components/apiHooks/generalRequestErrorHandler";

export const isLocalStorageAvailable = () => {
	try {
		const testKey = "__test_key__";

		localStorage.setItem(testKey, testKey);
		localStorage.removeItem(testKey);

		return true;
	} catch (e) {
		console.error(
			"localStorage is not available. Please check your browser settings or disable private browsing."
		);
		generalRequestErrorHandler(e);

		return false;
	}
};

export const getLocalStorageValue = <T>(key: string, initialValue: T): T => {
	if (!isLocalStorageAvailable()) {
		return initialValue;
	}
	try {
		const item = globalThis.localStorage.getItem(key);

		return item ? JSON.parse(item) : initialValue;
	} catch (error) {
		console.error(error);

		return initialValue;
	}
};

export const setLocalStorageValue = <T>(key: string, value: T | ((val: T) => T)): void => {
	if (!isLocalStorageAvailable()) {
		return;
	}
	try {
		const valueToStore =
			typeof value === "function" ? value(getLocalStorageValue(key, undefined as T)) : value;

		globalThis.localStorage.setItem(key, JSON.stringify(valueToStore));
	} catch (error) {
		console.error(error);
	}
};

export const removeLocalStorageValue = (key: string): void => {
	if (!isLocalStorageAvailable()) {
		return;
	}
	try {
		globalThis.localStorage.removeItem(key);
	} catch (error) {
		console.error(error);
	}
};

export const clearAllLocalStorage = () => {
	if (!isLocalStorageAvailable()) {
		return;
	}
	try {
		globalThis.localStorage.clear();
	} catch (error) {
		console.error(error);
	}
};
